var _rect, _line, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownReporting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 8,
    fill: "#143232"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.5,
    y1: 7,
    x2: 1.5,
    y2: 3,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7V1.5M5.5 7V5M3.5 7L3.5 1",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownReporting);
export default __webpack_public_path__ + "static/media/dropdown-reporting.e1c4be4d40048b7528c2fd1742374b45.svg";
export { ForwardRef as ReactComponent };